import { EActionType } from 'shared/types/dailyrent';
import { actionGenerator } from 'shared/utils/redux/actionGenerator';

import { EDailyrentActionTypeTypes } from './types';

export const setDailyrentActionType = actionGenerator<EDailyrentActionTypeTypes.SetActionType, EActionType>(
  EDailyrentActionTypeTypes.SetActionType,
);

export * from './types';
